module.exports = __webpack_public_path__ + "img/title-en.a38e5823.png";